enum ThemeBodyClass {
    DARK_THEME = 'dark-theme',
    LIGHT_THEME = 'light-theme',
    OUTRUN_THEME = 'outrun-theme',
    BLACK_WHITE_THEME ='black-white-theme'
}

export default ThemeBodyClass;